import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateField } from "../../contexts/Utils";
import TimeoutUtility from "../../contexts/TimeoutUtility";
import { GetAllAccountTypes, AddAccountOpeningBal } from "../../api";
import { Header, Button } from "../../components";
import { useStateContext } from "../../contexts/ContextProvider";
import "../../styles/AddPart.css";
import { Container, Col, Row } from "react-bootstrap";
import TextAreaField from "../../components/TextAreaField";
import TextInputField from "../../components/TextInputField";
import DoubleField from "../../components/DoubleField";
import SelectField from "../../components/SelectField";
import { showSuccessToast, showErrorToast } from "../../components/ToastMesg";

const AddAccount = () => {
  const navigate = useNavigate();
  const { storeG } = useStateContext();
  const [getacc_types, setacc_types] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    description: "",
    type: "Select Type",
    balance: "0",
    notes: "",
  });
  const [errors, setErrors] = useState({});
  const [loadBtn, setLoadBtn] = useState(false);

  const handleBackClick = () => {
    TimeoutUtility.resetTimeout();
    navigate("/Account");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    const error = validateField(name, value, name);
    setErrors((prev) => ({ ...prev, [name]: error }));
  };

  const handleSelectChange = (option, e) => {
    if (option && option.value) {
      setFormData((prev) => ({ ...prev, [e.name]: option }));
      const error = validateField(e.name, option, e.name);
      setErrors((prev) => ({ ...prev, [e.name]: error }));
    } else setFormData((prev) => ({ ...prev, [e.name]: "Select Type" }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    TimeoutUtility.resetTimeout();
    setLoadBtn(true);

    // Validate all fields
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key], key);
      if (error) newErrors[key] = error;
    });
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      setLoadBtn(false);
      return;
    }
    const type_id = formData.type.value;
    try {
      const response = await AddAccountOpeningBal(
        storeG.store_id,
        formData.name,
        formData.description,
        formData.balance,
        type_id,
        formData.notes,
      );
      if (response.success) {
        showSuccessToast("Success!", "Account added successfully!");
        navigate("/Account");
      } else
        showErrorToast(
          "Error!",
          "Account failed to add!\n\n" + response.message,
        );
    } catch (err) {
      showErrorToast("Error!", "Account failed to add!");
    } finally {
      setLoadBtn(false);
    }
  };

  useEffect(() => {
    TimeoutUtility.resetTimeout();
    const fetchData = async () => {
      await GetAllAccountTypes()
        .then((resp) => {
          const typeOptions = resp.data.map((item) => ({
            label: item.name,
            value: item.a_type_id,
          }));
          setacc_types(typeOptions || []);
        })
        .catch((err) => console.log(err.message));
    };
    fetchData();
  }, []);

  return (
    <div className="m-0 md:m-4 p-4 md:p-8 main-div-bg">
      <Header title="ADD ACCOUNT" />
      <form>
        <Container className="g-0 form-container" fluid="true">
          <Row xs={1} sm={1} className="p-0 justify-content-center">
            <Col md={6} className="container-col">
              <div className="col-lg-12">
                <TextInputField
                  label="Account Title:"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Account Title"
                  compulsory={true}
                  error={errors.name}
                />
                <TextInputField
                  label="Description:"
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  placeholder="Description"
                  compulsory={true}
                  error={errors.description}
                />
                <SelectField
                  label="Account Type:"
                  name="type"
                  value={formData.type}
                  options={getacc_types}
                  onChange={handleSelectChange}
                  placeholder="Account Type"
                  compulsory={true}
                  error={errors.type}
                />
                <DoubleField
                  label="Opening Balance:"
                  name="balance"
                  value={formData.balance}
                  onChange={handleChange}
                  placeholder="Opening Balance"
                  min="0"
                  step="1.00"
                  compulsory={true}
                  error={errors.balance}
                />
                <TextAreaField
                  label="Note:"
                  name="notes"
                  value={formData.notes}
                  onChange={handleChange}
                  placeholder="Notes"
                  error={errors.notes}
                />
              </div>
            </Col>
          </Row>
        </Container>
      </form>
      <Row md={"auto"} className="justify-content-center pt-12">
        <Button
          margin="10px"
          padding="20px"
          text="Add"
          onClick={handleSubmit}
          disabled={loadBtn}
        />
        <Button
          margin="10px"
          padding="20px"
          text="Back"
          onClick={handleBackClick}
        />
      </Row>
    </div>
  );
};

export default AddAccount;
